import { PromoProductFamily } from "../entities/promo-product-family.entity";
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';


export class PromoProductFamilyRequest extends BaseRequest {

    promoProductFamily : PromoProductFamily;
}
